import React,{useState,useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/home';
import Products from './pages/products';
import ProductsPack from './pages/products-pack';
import Product from './pages/product-details';
import Notification from './pages/notification';
import Contact from './pages/contact-us';
import Profile from './pages/profile';
import Help from './pages/help';
import Favorite from './pages/favorite';
import Orders from './pages/orders';
import Tickets from './pages/tickets';
import Payment from './pages/payment';
import Report from './pages/report';
import OrderList from './pages/order-list';
import Navbar from './layout/navbar/navbar';
import Menu from './layout/menu/menu';
import MainLayout from './layout/layout';
import { isMobile } from 'react-device-detect';


const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isMobile;
};
const RouterComponent = () => {
    return (
        <Router>
            <Layout />
        </Router>
    );
};

const Layout = () => {
    const location = useLocation();
    const isMobile = useIsMobile(); // ✅ تشخیص موبایل با متد جدید

    const isProfilePage = location.pathname === '/report' ||  location.pathname === '/payment' ||location.pathname === '/profile' || location.pathname === '/notification' || location.pathname === '/orders' || location.pathname === '/help' || location.pathname === '/favorite'
    || location.pathname === '/order-list'
    || location.pathname === '/tickets'
    ;

    return (
<div className={` ${isProfilePage && !isMobile ? 'd-flex gap-2 bg-[#FAFAFC]' : ''} `}>
{isProfilePage ? <Menu /> : <Navbar />}
            <div className="App flex-1">
                <Routes>
                    <Route path="/" element={<MainLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/products-pack" element={<ProductsPack />} />
                        <Route path="/product" element={<Product />} />
                        <Route path="/contact-us" element={<Contact />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/help" element={<Help />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/order-list" element={<OrderList />} />
                        <Route path="/payment" element={<Payment />} />
                        <Route path="/favorite" element={<Favorite />} />
                        <Route path="/tickets" element={<Tickets />} />
                        <Route path="/report" element={<Report />} />
                        <Route path="/notification" element={<Notification />} />
                    </Route>
                </Routes>
            </div>
        </div>
    );
};

export default RouterComponent;
